export default __webpack_public_path__ + "icon_emergency_help.7aff844120e0f769981f2a132a1e2d29.svg";